import Skills from "../components/skills_section/Skills";
import AboutSec from "../components/about_section/About";
import Contact from "../components/contact_section/Contact";
import About from "../components/first_section_about/About";
import Projects from "../components/projects_section/Projects";
const Home_page = () => {
  //  right now in the last videos we complete this page :))
  // dont forget to subscribe


  return (
    <>
      <About />
      <AboutSec />
      <Projects />
      <Skills />
      <Contact />
      {/* 
        *TODO - Create Component To extract detail from github
        *TODO - Create Project Details Component
    */}

    </>
  );
};
export default Home_page;
